// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPlusOutlinedSvg from "@fishx/icons-svg/es/asn/PPlusOutlined";
import FishxIcon from '../components/FishxIcon';

var PPlusOutlined = function PPlusOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPlusOutlinedSvg
  }));
};

PPlusOutlined.displayName = 'PPlusOutlined';
export default React.forwardRef(PPlusOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPlusOutlined.js
// module id = 3548
// module chunks = 0